function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

const clearAllDatabases = async () => {
  const databases = await indexedDB.databases();
  for (const db of databases) {
    await indexedDB.deleteDatabase(db.name);
  }
};

function clearAllCookies() {
  clearAllDatabases();
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [name, _] = cookie.split("=");
    deleteCookie(name);
  }
}
export default clearAllCookies;
